import { forwardRef, useCallback, useRef } from 'react';
import { ScrollView, type ScrollViewProps } from 'react-native';
import { useWebDragToScroll } from '../../../../hooks';

/**
 * 가로 `ScrollView` 드롭인 대체 — web(데스크톱)에서 마우스 click-drag 로 스크롤되도록
 * useWebDragToScroll 을 내부에 붙인다(터치/네이티브에선 no-op).
 *
 * 브라우저는 overflow 컨테이너를 마우스 드래그로 스크롤하지 않아(휠/트랙패드만),
 * RN Web 의 가로 ScrollView 는 데스크톱에서 스크롤이 막힌 것처럼 보인다. 이 래퍼로
 * `<ScrollView horizontal>` 을 교체하면 각 소비 컴포넌트에 ref/훅 배선 없이 해결된다.
 *
 * 페이지 스냅/인덱스 정착이 필요한 캐러셀(pagingEnabled 등)은 BannerScrollView 를 쓸 것.
 */
export const HorizontalDragScrollView = forwardRef<ScrollView, ScrollViewProps>(
  (props, ref) => {
    // drag 훅은 내부 ref 로 동작시키고, 소비 측이 넘긴 ref 에도 동일 노드를 전달한다.
    const innerRef = useRef<ScrollView>(null);
    useWebDragToScroll(innerRef);

    const setRefs = useCallback(
      (node: ScrollView | null) => {
        innerRef.current = node;
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref) {
          ref.current = node;
        }
      },
      [ref],
    );

    return <ScrollView ref={setRefs} {...props} />;
  },
);

HorizontalDragScrollView.displayName = 'HorizontalDragScrollView';
